module.exports = __webpack_public_path__ + "static/img/iconyangshengqi_24_hei.dba93574.png";